module.exports = __webpack_public_path__ + "img/download_excelicon_disabled.4d143eab.svg";